import { useState, type ReactNode } from 'react';

/** Tap a picture to see it big; tap anywhere to put it back. */
export function useLightbox(): { open: (url: string, caption?: string) => void; lightbox: ReactNode } {
  const [img, setImg] = useState<{ url: string; caption?: string } | null>(null);
  const lightbox = img ? (
    <div className="lightbox" role="dialog" aria-label={img.caption || 'Picture'} onClick={() => setImg(null)}>
      <img src={img.url} alt={img.caption || ''} />
      {img.caption && <span className="lightbox-cap">{img.caption}</span>}
      <span className="hint" style={{ color: 'rgba(255,255,255,.7)' }}>Tap to close</span>
    </div>
  ) : null;
  return { open: (url, caption) => setImg({ url, caption }), lightbox };
}
